













































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentRecalcularImpostosEAlugueis extends Vue {
  loadRecalculo: boolean = false

  get showModal() { return this.getFinanceiroStore.modal.recalcularImpostosEAlugueis }
  set showModal(value: boolean) { this.getFinanceiroStore.setModal({ name: 'recalcularImpostosEAlugueis', value }) }

  get loadingRecalcularImpostos() { return this.loadRecalculo }
  set loadingRecalcularImpostos(value: boolean) { this.loadRecalculo = value }

  async recalcular() {
    this.loadingRecalcularImpostos = true
    const response: any = await this.getFinanceiroStore.recalcularImpostos()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O recalculo dos repasses foi feito com sucesso!', icon: 'done', color: '#2E7D32' })
      let id: string = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
      this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
      this.showModal = false
      this.getFinanceiroStore.setModal({ name: 'recalcularImpostosEAlugueis', value: false })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao recalcular os repasses.', icon: 'warning', color: '#C62828' })
    }
    this.loadingRecalcularImpostos = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
